"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseStringAmount = void 0;
const replaceAll_1 = require("../replaceAll");
const fraction_js_1 = __importDefault(require("fraction.js"));
const betweenRegex = /(\d+)(-| to )(\d+)/;
exports.parseStringAmount = (amount) => {
    const match = amount.match(betweenRegex);
    if (match) {
        const [, s1, , s2] = match;
        const n1 = parseInt(s1, 10);
        const n2 = parseInt(s2, 10);
        const nan1 = isNaN(n1);
        const nan2 = isNaN(n2);
        if (nan1) {
            return [];
        }
        else if (nan2) {
            return [];
        }
        return [n1, n2];
    }
    try {
        const n = 0.0 + fraction_js_1.default(replaceAll_1.replaceAll(amount, replaceAll_1.fractionToText));
        if (isNaN(n)) {
            return [];
        }
        return [n];
    }
    catch (_a) {
        return [];
    }
};
//# sourceMappingURL=parseStringAmount.js.map